import React from "react";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";

const FixedNavbar = props => (
  <nav
    className={`navbar is-dark
      ${props.fixed && "is-fixed-top animated slideInDown"}`}
    style={{
      zIndex: "100",
      width: "100vw",
      position: !props.fixed && "absolute"
    }}
  >
    <div className="container">
      {/* Logo Linking to Home Page */}
      <div className="navbar-brand">
        <Link to="/" className="navbar-item">
          <img src={props.logo} alt="Accratronics Seals, LLC." />
        </Link>

        {/* Toggleable 'sidebar' styled icon for mobile*/}
        <div
          className={`navbar-burger ${props.active && "is-active"}`}
          onClick={props.onIconClick}
        >
          <span />
          <span />
          <span />
        </div>
      </div>

      {/* Main Navbar Menu: Links go here */}
      <div className={`navbar-menu ${props.active && "is-active"}`}>
        {/* Left side of menu */}
        <div className="navbar-start" />{" "}
        {/*.navbar-start is empty, but necessary */}
        {/* Right side of menu */}
        <div className="navbar-end">
          {props.links.map((item, i) => {
            return item.type === "link" ? (
              <NavLink
                key={i}
                to={item.path}
                exact={item.exact}
                // TODO: make sure that onClick method actually works here
                onClick={props.onNavLinkClick}
                className={
                  !item.isButton
                    ? "navbar-item"
                    : "navbar-item no-hover-effects"
                }
                activeClassName={!item.isButton ? "is-active" : ""}
              >
                {item.isButton && (
                  <button className="button is-brand">{item.title}</button>
                )}
                {!item.isButton && <span>{item.title}</span>}
              </NavLink>
            ) : (
              <div key={i} className="navbar-item has-dropdown is-hoverable">
                <div className="navbar-link">{item.title}</div>
                <div className="navbar-dropdown">
                  {item.contents.map((subItem, i) => (
                    <NavLink onClick={props.onNavLinkClick} className="navbar-item" to={subItem.path} key={i}>
                      {subItem.title}
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </nav>
);

FixedNavbar.propTypes = {
  active: PropTypes.bool,
  fixed: PropTypes.bool,
  logo: PropTypes.string,
  onClick: PropTypes.func,
  onIconClick: PropTypes.func
};

FixedNavbar.defaultProps = {
  active: false,
  fixed: false,
  logo: process.env.PUBLIC_URL + "/images/ATS-Logo-Light.png"
};

export default FixedNavbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/FixedNavbar.js